import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Diensten', path: '/services' },
    { name: 'Prijzen', path: '/pricing' },
    { name: 'Over Ons', path: '/about' },
    { name: 'Portfolio', path: '/restaurant-portfolio' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 w-10 h-10 rounded-lg flex items-center justify-center transition-transform group-hover:scale-105">
              <img
                src="images/logo-white.png"
                alt="Upxero logo"
                className="w-6 h-6"
              />
            </div>
            <span className="text-2xl font-bold text-blue-900">UPXERO</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors relative group ${
                  location.pathname === link.path
                    ? 'text-blue-900'
                    : 'text-gray-700 hover:text-blue-900'
                }`}
              >
                {link.name}
                <span
                  className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-orange-500 transition-all group-hover:w-full ${
                    location.pathname === link.path ? 'w-full' : ''
                  }`}
                />
              </Link>
            ))}
          </nav>

          {/* CTA Buttons Desktop */}
          <div className="hidden md:flex items-center gap-4">

            {/* Plaats Gratis Vacature */}
            <a
              href="https://talent.upxero.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                className="border-2 border-blue-900 text-blue-900 hover:bg-blue-50 px-6 py-2.5 rounded-lg font-semibold transition-all hover:shadow-md"
              >
                Plaats Gratis Vacature
              </Button>
            </a>

            {/* Vraag Gratis Preview */}
            <Link to="/contact">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2.5 rounded-lg font-semibold transition-all hover:shadow-lg hover:scale-105">
                Vraag Gratis Preview Aan
              </Button>
            </Link>

          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="px-4 py-4 space-y-3">

            {/* Navigatie links */}
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-2.5 rounded-lg text-base font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-blue-50 text-blue-900'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}

            {/* Divider */}
            <div className="pt-4 mt-4 border-t border-gray-200 flex flex-col gap-4">

              {/* Plaats Gratis Vacature */}
              <a
                href="https://talent.upxero.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Button
                  variant="outline"
                  className="w-full border-2 border-blue-900 text-blue-900 hover:bg-blue-50 py-2.5 rounded-lg font-semibold"
                >
                  Plaats Gratis Vacature
                </Button>
              </a>

              {/* Vraag Gratis Preview */}
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2.5 rounded-lg font-semibold">
                  Vraag Gratis Preview Aan
                </Button>
              </Link>

            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
